import React, { useCallback, useEffect, useRef, useState } from "react";
import EmailCollectionRefusal from "../components/EmailCollectionRefusal/EmailCollectionRefusal";
import useTabs from "../hooks/useTabs";
import * as apis from "../apis";

export default function EmailCollectionRefusalContainer() {
  const tabButtons = [
    { id: 1, tab: "한국어", locale: "ko" },
    { id: 2, tab: "영문", locale: "en" },
  ];

  const { currentItem, changeItem } = useTabs(0, tabButtons);

  const editorRef = useRef(null);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [privacyPolicy, setPrivacyPolicy] = useState({
    content: "",
    locale: currentItem.locale,
  });

  useEffect(() => {
    const fetchEmailCollectionRefusal = async () => {
      try {
        const res = await apis.getEmailCollectionRefusal(currentItem.locale);
        setPrivacyPolicy(res?.data?.data);
        setIsDataLoaded(true);
      } catch (error) {
        console.error(error);
        alert(
          error.response?.data?.message ||
            "이메일 수집 거부를 불러오는데 실패 하였습니다."
        );
      }
    };
    fetchEmailCollectionRefusal();
  }, [currentItem.locale]);

  const handleEditorChange = (name, value) => {
    setPrivacyPolicy((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = useCallback(async () => {
    if (!privacyPolicy.content.trim()) {
      alert("이메일 수집 거부를 입력해주세요.");
      return;
    }

    try {
      if (window.confirm("이메일 수집 거부를 저장하시겠습니까?")) {
        await apis.updateEmailCollectionRefusal(privacyPolicy);
        const message =
          privacyPolicy.locale === "ko"
            ? "한국어 이메일 수집 거부가 저장되었습니다."
            : "영문 이메일 수집 거부가 저장되었습니다.";

        alert(message);
      }
    } catch (error) {
      console.error(error);
      alert(
        error.response?.data?.message ||
          "이메일 수집 거부를 저장하는데 실패 하였습니다."
      );
    }
  }, [privacyPolicy]);

  return (
    <>
      {isDataLoaded && (
        <EmailCollectionRefusal
          tabButtons={tabButtons}
          currentItem={currentItem}
          changeItem={changeItem}
          privacyPolicy={privacyPolicy}
          editorRef={editorRef}
          handleEditorChange={handleEditorChange}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
}
